import { Map } from "immutable";
import { resolveEach } from "redux-resolver";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import {
  createAttachmentReducer,
  createNoteReducer,
  attachmentsInitialState,
  notesInitialState
} from "MODULES/shared/reducer";
import * as actionTypes from "./actionTypes";

export const initialState = Map({
  purchaseOrder: Map()
})
  .merge(notesInitialState)
  .merge(attachmentsInitialState);

export default resolveEach(initialState, {
  [actionTypes.SET]: (state, action) =>
    state.merge({ purchaseOrder: action.purchaseOrder }),
  ...createAttachmentReducer(resourceTypes.purchaseOrder),
  ...createNoteReducer(resourceTypes.purchaseOrder)
});



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/reducer.js